import { ReactElement } from 'react';

import { EmptyState, EmptyStateProps } from '@components/empty-state';
import { IconProps } from '@components/icons';
import { IconSearch } from '@components/icons/search';
import { useScopedTranslate } from '@locale/translate';

export type EmptySearchStateProps = Pick<
  EmptyStateProps,
  'skipMargin' | 'orientation' | 'variant'
> & {
  hasFilters?: boolean;
  icon?: ReactElement<IconProps>;
};

export const EmptySearchState: React.FC<EmptySearchStateProps> = (props) => {
  const { t } = useScopedTranslate(locale);
  return (
    <EmptyState
      {...props}
      icon={props.icon ?? <IconSearch size={80} />}
      header={t('header')}
      content={props.hasFilters ? t('contentWFilters') : t('content')}
    />
  );
};

const locale = {
  en: {
    header: 'No results found',
    content: 'There are no results based on your search',
    contentWFilters:
      'There are no results based on your search\nTry adjusting your keyword or filters to find what you’re looking for',
  },
};
